import { get, post } from './client.js';

const base = (wsId) => `/workspaces/${wsId}/activities`;
const qs = (params) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v != null) q.set(k, v); });
  return q.toString() ? '?' + q.toString() : '';
};

export const list = (wsId, params = {}) => get(`${base(wsId)}${qs(params)}`);
export const listForDeal = (wsId, dealId, opts = {}) => list(wsId, { dealId, ...opts });
export const create = (wsId, body) => post(base(wsId), body);

const _actCat = (raw) => {
  const t = (raw || 'activity').toLowerCase();
  if (t === 'note'     || t.startsWith('note_'))     return 'note';
  if (t === 'call'     || t.startsWith('call_'))     return 'call';
  if (t === 'email'    || t.startsWith('email_'))    return 'email';
  if (t === 'meeting'  || t.startsWith('meeting_'))  return 'meeting';
  if (t === 'whatsapp' || t.startsWith('whatsapp_')) return 'whatsapp';
  if (t === 'followup' || t.startsWith('followup_')) return 'followup';
  if (t.startsWith('deal'))                          return 'deal';
  if (t.startsWith('task'))                          return 'task';
  return t;
};

const _relTime = (iso) => {
  if (!iso) return 'just now';
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 60000)     return 'just now';
  if (ms < 3600000)   return Math.floor(ms / 60000) + 'm ago';
  if (ms < 86400000)  return Math.floor(ms / 3600000) + 'h ago';
  if (ms < 172800000) return 'yesterday';
  return new Date(iso).toLocaleDateString('en-IN');
};

export const normActivity = (a) => ({
  id:        a.id,
  type:      _actCat(a.type),
  who:       a.actor     || 'System',
  what:      a.description || '',
  detail:    a.detail    || '',
  time:      _relTime(a.createdAt),
  createdAt: a.createdAt || null,
  personId:  a.personId  || null,
  companyId: a.companyId || null,
  dealId:    a.dealId    || null,
  taskId:    a.taskId    || null,
});
